export default [
  {
    path: '/config',
    component: () => import('./views/Index'),
    name: 'config',
    redirect: { name: 'config-list' },
    children: [
      {
        path: '',
        name: 'config-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'management',
        },
      },
    ],
  },
]
